import styled from "styled-components";
import { Typography } from "styled/Typography";

export const Title = styled(Typography.H2)`
  padding-left: 12px;
`;
